<template>
    <div id="turnstile-container" class="text-center mb-3"></div>
</template>

<script setup lang="ts">
import {computed, onMounted, ref} from "vue";
import {router} from "@inertiajs/vue3";

const emit = defineEmits(["verified"]);

const widgetId = ref(null);
const siteKey = computed(() => import.meta.env.VITE_TURNSTILE_SITE_KEY);

onMounted(() => {
    if (window.turnstile && siteKey.value) {
        widgetId.value = window.turnstile.render('#turnstile-container', {
            sitekey: siteKey.value,
            callback: (token : string) => {
                emit("verified", token);
            }
        });

        router.on("finish", () => {
            console.log("finish");

            if (widgetId.value) window.turnstile.reset(widgetId.value);
        });
    }
});

</script>
